import { getGutterValueInPixels } from '../../../util/styles/gutters';
import { mainContentColumnMaxWidth } from '../ContentMainColumn.types';
import {
  ContentSidebarPosition,
  contentSidebarLeftMaxWidth,
  contentSidebarRightMaxWidth,
} from '../ContentSidebarColumn.types';

import { useAppLayoutGutterSize } from './useAppLayoutContext';
import { useContentContainerContext } from './useContentContainerContext';

const getContentMaxWidth = (gutterSize: number, sidebarPosition?: ContentSidebarPosition) => {
  const gutterInPixels = getGutterValueInPixels(gutterSize);

  const sidebarWidth = sidebarPosition === 'left' ? contentSidebarLeftMaxWidth : contentSidebarRightMaxWidth;

  return mainContentColumnMaxWidth + sidebarWidth + gutterInPixels * 3;
};

type UseContentMaxWidth = () => number | undefined;
export const useContentMaxWidth: UseContentMaxWidth = () => {
  const { sidebarPosition } = useContentContainerContext();
  const { shouldFillAvailableSpace } = useContentContainerContext();
  const gutterSize = useAppLayoutGutterSize();

  if (shouldFillAvailableSpace) {
    return undefined;
  }

  return getContentMaxWidth(gutterSize, sidebarPosition);
};
